export default "__VITE_ASSET__BsZR000M__"